import * as React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom";





export default function BasicBreadcrumbs(props) {
    const navigate = useNavigate();

    const handlePage = (e,value) => {
        navigate('/room')
    }

  return (
    <div >
      <Breadcrumbs aria-label="breadcrumb">
      <Typography
          onClick={(e) => handlePage()}
          color="inherit"

        >
          My Account
        </Typography>
        <Typography sx={{ color: 'text.primary' }}>{props.title}</Typography>
     
       
      </Breadcrumbs>
    </div>
  );
}